import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketJobs from "components/Market/Jobs/Jobs";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketJobsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketJobs {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateHireJob: (jobId, isHire) => dispatch(marketReducer.updateHireJob(jobId, isHire)),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob)),
    deleteJob: (jobId) => dispatch(marketReducer.deleteJob(jobId))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    jobs: marketReducer.getJobsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketJobsContainer);
